/**
 * This is needed to resolve race conditions between Chrome and Applications.
 * There were application teams reporting issues where their settings
 * were not taking place because Chrome was initializaing with the data printed
 * on the page at the same time the application was updating the Chrome API.
 *
 * See https://t.corp.amazon.com/V842965942
 */

const unRenderedComponents = new Set(['header', 'footer', 'pivotNav', 'nav']);

const CHROME_COMPONENTS_INITIALIZED = 'CHROME_COMPONENTS_INITIALIZED';

export const markComponentRendered = (
  component: 'header' | 'footer' | 'pivotNav' | 'nav',
) => {
  unRenderedComponents.delete(component);
  if (unRenderedComponents.size === 0) {
    window.AACChrome = window.AACChrome || {};
    window.AACChrome.hasInitialized = true;
    window.dispatchEvent(new CustomEvent(CHROME_COMPONENTS_INITIALIZED));
  }
};
